import { useEffect, useState } from 'react';
import api from './api';

/**
 * Active couriers for public/portal dropdowns (report form, home page quick
 * track, merchant "create case"). Admin-managed via /admin/courier-intelligence
 * — this always reflects whatever is currently active there.
 */
export const useCouriers = () => {
  const [couriers, setCouriers] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/api/couriers')
      .then(({ data }) => {
        if (!cancelled) setCouriers(data || []);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return couriers;
};
